import styled from "styled-components";

export const BlackBgWrap = styled.div`
  width: 100%;
  height: 100%;
  z-index: -2;
  background-color: black;
  position: absolute;
`;
